import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { createStore } from 'redux';
import { Provider } from 'react-redux';
import settings from './reducers/index';

let store = createStore(settings);
//console.log(store.getState());

ReactDOM.render(
  <Provider store={store}>
    <div>
      <React.StrictMode>
          <App />
      </React.StrictMode>
    </div>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();